/* eslint-disable */
import axios from 'axios';
import { getHost } from '@/helpers/common';
class ApiService {

  constructor() {

    const host = getHost(window);

    const instance = axios.create({
      baseURL: host,
      timeout: 1000,
      headers: {}
    });

    instance.interceptors.request.use(this.beforeRequest, this.handleRequestError);
    instance.interceptors.response.use(this.handleSuccess, this.handleError);

    this.$http = instance;
  }

  /**
   *
   * @param {*} document
   * @param {*} path
   */
  redirectTo(document, path) {
    document.location = path;
  }

  beforeRequest(conf) {
    return conf;
  }

  handleRequestError(error) {
    return Promise.reject(error);
  }

  /**
   *
   * @param {*} response
   */
  handleSuccess(response) {
    return response;
  }

  /**
   *
   * @param {*} error
   */
  handleError(error) {
    // switch (error.response.status) {
    //   case 401:
    //     this.redirectTo(document, '/');
    //     break;
    //   case 404:
    //     this.redirectTo(document, '/404');
    //     break;
    //   default:
    //     this.redirectTo(document, '/500');
    //     break;
    // }
    return Promise.reject(error);
  }
}

const API = new ApiService();

export default API;
